import { render, staticRenderFns } from "./ChannelEntityListSynchronizationCmp.vue?vue&type=template&id=8495deb0&scoped=true&"
import script from "./ChannelEntityListSynchronizationCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelEntityListSynchronizationCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelEntityListSynchronizationCmp.vue?vue&type=style&index=0&id=8495deb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495deb0",
  null
  
)

export default component.exports